import { Link } from 'react-router-dom'
import NotificationBar from './NotificationBar';

interface NavProps {
	className?: string;
}

const Nav = ({ className = '' }: NavProps) => {

	const Logo = ({ fill = "#FF5C00" }: { fill?: string }) => (
		<Link to="/" aria-label="Go to home">
			{/* <svg className="h-7 w-auto" viewBox="0 0 98 33" fill="none" xmlns="http://www.w3.org/2000/svg">
				<path d="M27.6441 17.0236L30.5811 14.0866C32.076 12.5939 33 10.5303 33 8.2511C33 3.6949 29.3061 0.00109999 24.75 0.00109999C22.4708 0.00109999 20.4072 0.9251 18.9145 2.42L16.5011 4.8334V0H0V16.5H4.8323L2.4134 18.9189C0.9229 20.4116 0 22.473 0 24.75C0 29.3061 3.6938 33 8.25 33C10.5292 33 12.5928 32.076 14.0855 30.5811L17.0225 27.6441C18.1951 30.7724 21.2113 33 24.7489 33C29.3051 33 32.9989 29.3061 32.9989 24.75C32.9989 21.2124 30.7713 18.1951 27.643 17.0236H27.6441Z"
					fill={fill}
					style={{ fill: fill, fillOpacity: 1 }} />
				<path d="M91.1424 25.6678C88.2139 25.6678 86.0645 23.5721 86.0645 20.4555V11.8579H89.1273V19.8644C89.1273 21.7451 90.1752 22.8736 91.8141 22.8736C93.5605 22.8736 94.6889 21.5839 94.6889 19.6495V11.8579H97.7518V25.3454H95.065L94.9307 23.8945H94.7695C93.9366 25.023 92.7813 25.6678 91.1424 25.6678Z"
					fill={fill}
					style={{ fill: fill, fillOpacity: 1 }} />
				<path d="M76.8406 25.667C74.9868 25.667 73.4285 24.9416 72.6224 23.7325H72.4612L72.3 25.3446H69.6133V6H72.6762V13.2811H72.8374C73.6703 12.1795 75.1211 11.5347 76.8675 11.5347C80.414 11.5347 83.047 14.5438 83.047 18.6008C83.047 22.6578 80.414 25.667 76.8406 25.667ZM76.2227 22.8996C78.3721 22.8996 79.8498 21.1532 79.8498 18.6008C79.8498 16.0484 78.3721 14.302 76.2227 14.302C74.0733 14.302 72.6762 16.0216 72.6762 18.6008C72.6762 21.207 74.0733 22.8996 76.2227 22.8996Z"
					fill={fill}
					style={{ fill: fill, fillOpacity: 1 }} />
				<path d="M62.9245 25.3445V11.8571H65.9874V25.3445H62.9245ZM64.4559 9.92262C63.3812 9.92262 62.5215 9.08973 62.5215 7.98817C62.5215 6.8866 63.3812 6.05371 64.4559 6.05371C65.5306 6.05371 66.3904 6.8866 66.3904 7.98817C66.3904 9.08973 65.5306 9.92262 64.4559 9.92262Z"
					fill={fill}
					style={{ fill: fill, fillOpacity: 1 }} />
				<path d="M46.248 25.3448V6.5376H49.4184V14.2486H50.7886L56.3233 6.5376H60.0848L53.5829 15.5919V15.7531L60.4878 25.3448H56.7263L50.7886 17.1234H49.4184V25.3448H46.248Z"
					fill={fill}
					style={{ fill: fill, fillOpacity: 1 }} />
			</svg> */}
			< svg className="h-7 w-auto" viewBox="0 0 3276 669" fill="none" xmlns="http://www.w3.org/2000/svg" >
				<path d="M3149.28 518.576C3111.47 518.576 3079.68 503.78 3063.24 479.12H3059.95L3056.67 512H3001.87V117.44H3064.34V265.948H3067.63C3084.61 243.48 3114.21 230.328 3149.83 230.328C3222.16 230.328 3275.87 291.704 3275.87 374.452C3275.87 457.2 3222.16 518.576 3149.28 518.576ZM3064.34 374.452C3064.34 427.608 3092.83 462.132 3136.67 462.132C3180.51 462.132 3210.65 426.512 3210.65 374.452C3210.65 322.392 3180.51 286.772 3136.67 286.772C3092.83 286.772 3064.34 321.844 3064.34 374.452Z"
					fill={fill}
					style={{ fill: fill, fillOpacity: 1 }} />
				<path d="M2792.37 518.576C2732.64 518.576 2688.8 475.832 2688.8 412.264V236.904H2751.27V400.208C2751.27 438.568 2772.64 461.584 2806.07 461.584C2841.69 461.584 2864.71 435.28 2864.71 395.824V236.904H2927.18V512H2872.38L2869.64 482.408H2866.35C2849.36 505.424 2825.8 518.576 2792.37 518.576Z"
					fill={fill}
					style={{ fill: fill, fillOpacity: 1 }} />
				<path d="M2552.33 512V117.44H2614.81V512H2552.33Z"
					fill={fill}
					style={{ fill: fill, fillOpacity: 1 }} />
				<path d="M2323.84 518.576C2212.05 518.576 2135.33 435.28 2135.33 320.748C2135.33 207.312 2213.7 121.824 2323.84 121.824C2410.43 121.824 2481.12 174.432 2494.27 251.152H2426.87C2411.52 205.668 2373.16 181.556 2323.84 181.556C2249.86 181.556 2202.19 235.808 2202.19 320.2C2202.19 399.112 2246.58 458.844 2323.84 458.844C2372.62 458.844 2412.62 435.828 2427.42 389.248H2494.82C2482.22 467.064 2411.52 518.576 2323.84 518.576Z"
					fill={fill}
					style={{ fill: fill, fillOpacity: 1 }} />
				<path d="M560.421 345.115L619.962 285.574C650.268 255.313 669 213.478 669 167.272C669 74.9057 594.115 0.0222998 501.75 0.0222998C455.544 0.0222998 413.71 18.7543 383.448 49.06L334.522 97.9862V0H0V334.5H97.9639L48.9262 383.538C18.7097 413.799 0 455.589 0 501.75C0 594.115 74.8834 669 167.25 669C213.456 669 255.29 650.268 285.552 619.962L345.092 560.421C368.864 623.84 430.011 669 501.728 669C594.094 669 668.978 594.115 668.978 501.75C668.978 430.033 623.818 368.864 560.399 345.115H560.421Z"
					fill={fill}
					style={{ fill: fill, fillOpacity: 1 }} />
				<path d="M1847.7 520.356C1788.34 520.356 1744.76 477.871 1744.76 414.689V240.392H1806.85V402.706C1806.85 440.833 1828.1 463.71 1861.32 463.71C1896.73 463.71 1919.6 437.565 1919.6 398.349V240.392H1981.69V513.82H1927.23L1924.5 484.407H1921.24C1904.35 507.285 1880.93 520.356 1847.7 520.356Z"
					fill={fill}
					style={{ fill: fill, fillOpacity: 1 }} />
				<path d="M1557.77 520.34C1520.19 520.34 1488.6 505.634 1472.25 481.123H1468.99L1465.72 513.804H1411.25V121.636H1473.34V269.244H1476.61C1493.5 246.912 1522.91 233.84 1558.31 233.84C1630.21 233.84 1683.59 294.843 1683.59 377.089C1683.59 459.336 1630.21 520.34 1557.77 520.34ZM1545.24 464.237C1588.82 464.237 1618.77 428.833 1618.77 377.089C1618.77 325.345 1588.82 289.941 1545.24 289.941C1501.67 289.941 1473.34 324.802 1473.34 377.089C1473.34 429.924 1501.67 464.237 1545.24 464.237Z"
					fill={fill}
					style={{ fill: fill, fillOpacity: 1 }} />
				<path d="M1275.65 513.802V240.376H1337.74V513.802H1275.65ZM1306.7 201.159C1284.91 201.159 1267.48 184.274 1267.48 161.942C1267.48 139.61 1284.91 122.725 1306.7 122.725C1328.48 122.725 1345.91 139.61 1345.91 161.942C1345.91 184.274 1328.48 201.159 1306.7 201.159Z"
					fill={fill}
					style={{ fill: fill, fillOpacity: 1 }} />
				<path d="M937.574 513.808V132.535H1001.85V288.858H1029.62L1141.83 132.535H1218.08L1086.27 316.09V319.358L1226.25 513.808H1150L1029.62 347.138H1001.85V513.808H937.574Z"
					fill={fill}
					style={{ fill: fill, fillOpacity: 1 }} />
			</svg >
		</Link>
	)




	return (
		<nav
			className={`bg-yellow h-[70px] w-full z-100 ${className}`}
		>
			{/* Notification Bar */}
			{/* <NotificationBar /> */}

			<div className="bg-yellow md:pl-5 md:pr-5 pl-5 pr-5 w-full h-[70px] z-100">
				<div className="mx-auto flex justify-between items-center h-full w-full z-100">
					<Logo fill="white" />
					<Link
						to="/directions"
						className="bg-white text-yellow px-6 py-2 rounded-large font-headline hover:shadow-button-hover transition-all duration-300 text-sm md:text-base"
					>
						Directions
					</Link>
				</div>
			</div>
		</nav>
	)
}

export default Nav